import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowheadLeft = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fill: "#000",
		fillRule: "evenodd",
		d: "M12.447 13.894A1 1 0 0 1 11.4 13.8l-4-3a1 1 0 0 1 0-1.6l4-3A1 1 0 0 1 13 7v6a1 1 0 0 1-.553.894Z",
		clipRule: "evenodd"
	})]
});
const ForwardRef = forwardRef(SvgArrowheadLeft);
export { ForwardRef as ReactComponent };
